import { ModulePath, ModuleTitle } from '@common/types';
import { defineModule } from '@core/index';
import ILSAnalyticsTenderReportsContainer from './container';

export default defineModule({
  title: ModuleTitle.AnalyticsTenderReports,
  path: ModulePath.AnalyticsTenderReports,
  component: ILSAnalyticsTenderReportsContainer
});
